module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info_sferum"
  }, _vm._l((_vm.items), function(group) {
    return _c('SferumWebinarGroup', {
      key: group.group_id,
      attrs: {
        "group": group
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a45a66e","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/infoSferum/InfoSferum.vue
// module id = f30f19dc4f01cbb1a5f2
// module chunks = 14